<template>
  <Carousel :autoplay="12000">
    <Slide v-for="(slide, index) in dataSlides" :key="index">
      <div class="carousel__item" :style="'background-image:url(' + slide.PathUrl + ')'">
        <div class="container slide-block">
          <div :class="['slide-title animate-xs-fade-right', slide.type]">
            {{ lang == 'es' ? slide.title : slide.en_title }}
          </div>
        </div>
      </div>
    </Slide>

    <template #addons>
      <Pagination />
    </template>
  </Carousel>
</template>

<script>
import { Carousel, Navigation, Pagination, Slide } from 'vue3-carousel'

import 'vue3-carousel/dist/carousel.css'

export default {
  name: 'CarouselContent',
  components: {
    Carousel,
    Slide,
    Pagination,
    Navigation,
  },
  props: {
    lang: {
      type: String,
      default: 'es',
      required: false,
    },
  },
  data() {
    return {
      dataSlides: [],
      loading: {
        table: false,
      },
    }
  },
  mounted() {
    this.getData()
  },
  methods: {
    getData() {
      const self = this
      self.loading.table = true
      axios
        .get('/admin/slides')
        .then((res) => {
          if (res.data.success && res.data.data.length) {
            self.dataSlides = res.data.data
          }
        })
        .finally(() => {
          self.loading.table = false
        })
    },
  },
}
</script>
